<template>
    <div>
        <div class="previous-step" :class="{'active-previous-step': !!idSelectedCategory(selectedCategory)}"
             @click="back(idSelectedCategory(selectedCategory))">
            <div class="icon-container-previous-step">
                <span class="icon-previous-step" v-show="idSelectedCategory(selectedCategory)"> < </span>
            </div>
            <div class="previous-step-name">{{nameSelectedCategory(selectedCategory)}}</div>
        </div>
        <div
            v-if="subcategoriesList(selectedCategory).length === 0 && !selectedCategoryWithProducts(selectedCategory) && categoryDataLoadFlag"
            class="help-message">Загрузка ...
        </div>
        <div
            v-if="subcategoriesList(selectedCategory).length === 0 && !selectedCategoryWithProducts(selectedCategory) && !categoryDataLoadFlag"
            class="help-message">Список категорий продуктов пуст!
        </div>
        <div v-else>
            <div class="subcategory" v-for="value in subcategoriesList(selectedCategory)" @click="selectCategory(value.idCategory, value.nameCategory)">
                <div>{{value.nameCategory}}</div>
            </div>
        </div>
        <ProductsSidebar class="mt-30" :idSelectedCategory = "idSelectedCategory(selectedCategory)"/>
    </div>
</template>

<script>
    import ProductsSidebar from "./ProductsSidebar";
    // import {http_loggly} from "../../../httpConfig";
    // import {bus} from "../../../vue_bus";

    export default {
        name: "CategoriesAndProductsSidebarMenu",
        components: {ProductsSidebar},
        computed: {
            categoryDataLoadFlag(){
              return this.$store.state.UI.productCategories.dataLoadFlag;
            },
            selectedCategory(){
                return this.$store.getters["UI/productCategories/SELECTED_CATEGORY"];
            },
            planeDesignSettings(){
                return this.$store.getters["active/PLANE_DESIGN_SETTINGS"];
            },
            selectProductUUID(){
                if (this.planeDesignSettings && this.planeDesignSettings.uuidProduct){
                    return this.planeDesignSettings.uuidProduct;
                } else {
                    return null;
                }
            }
        },
        watch:{
            selectProductUUID(newValue){
                if(newValue){
                    this.openDesiredMenuItem(newValue);
                }
            }
        },
        methods: {
          selectedCategoryWithProducts(selectedCategory){
            return !!(this.subcategoriesList(selectedCategory).length === 0
                && this.idSelectedCategory);
          },
          subcategoriesList(selectedCategory) {
            if (!selectedCategory){
              return [];
            }

            const getCategoryList = (subcategories) => {
              let subcategoriesList = [];
              for (let idCategory in subcategories) {
                subcategoriesList.push({
                  idCategory: idCategory,
                  nameCategory: subcategories[idCategory].name
                });
              }
              return subcategoriesList;
            };

            if (selectedCategory.subcategories){
              return getCategoryList(selectedCategory.subcategories);
            } else {
              return getCategoryList(selectedCategory);
            }
          },
          objectLength(object){
            if (object)
              return Object.keys(object).length;
          },
          idSelectedCategory(selectedCategory){
            if (!selectedCategory){
              return null;
            }

            if(selectedCategory.id){
              return selectedCategory.id;
            } else {
              return null;
            }
          },
          nameSelectedCategory(selectedCategory) {
            if (!selectedCategory) {
              return 'Ошибка!'
            }

            if(selectedCategory.name){
              return selectedCategory.name;
            } else {
              return 'Корневой каталог';
            }
          },
          // sendLoggly() {
          //   let store_products, html, project_url, error;
          //   try {
          //     store_products = JSON.stringify(this.$store.state.UI.productCategories);
          //   } catch (err) {
          //     store_products = "Проблемы со store.state.UI.productCategories. Не выполнился JSON.stringify";
          //     error = err.message;
          //   }
          //
          //   try {
          //     html = this.$el.outerHTML;
          //   } catch (err) {
          //     html = "Проблемы с this.$el.outerHTML.";
          //     error = err.message;
          //   }
          //
          //   try {
          //     project_url = window.location;
          //   } catch (err) {
          //     project_url = "Ошибка!!!";
          //     error = err.message;
          //   }
          //
          //   http_loggly.post('', {
          //     title: "Product menu",
          //     project_url: project_url,
          //     store_products: store_products,
          //     html: html,
          //     error: error
          //   })
          //       .then((response) => {
          //         console.log(response);
          //       })
          //       .catch((err) => {
          //         console.log(err);
          //       })
          // },
          openDesiredMenuItem(uuidCategory) {
            const product = this.$store.getters["UI/products/PRODUCT_BY_UUID_ONLY_STORE"](uuidCategory);
                if(product){
                    this.$store.dispatch('UI/productCategories/REPRODUCE_TEMPLATE_SELECTED_CATEGORIES', product.hierarchy_ids);
                }
            },
            reset(){
                this.$store.commit('UI/productCategories/RESET_SELECTED_CATEGORIES');
            },
            back(idSelectedCategory){
                this.$store.commit('UI/productCategories/BACK_TO_CATEGORY', idSelectedCategory);
            },
            // goToCategory(idCategory){
            //     console.log(idCategory);
            // },
            selectCategory(idCategory, nameCategory){
                this.$store.commit('UI/productCategories/ADD_SELECTED_CATEGORIES', {
                    idCategory,
                    nameCategory
                });
            },
        },
        async mounted() {
            // this.$store.dispatch('UI/products/PRODUCT_CATEGORY_SELECTED', idCategory);
            await this.$store.dispatch('UI/productCategories/GET_CATEGORIES');
            if (this.selectProductUUID) {
                this.openDesiredMenuItem(this.selectProductUUID);
            }
            // bus.$on('sendDataOnError', this.sendLoggly);
        },
        destroyed() {
            // bus.$off('sendDataOnError');
        }
    }
</script>

<style scoped>
    .previous-step {
        padding: 10px 10px;
        /*border-bottom: 2px solid #f2f2f2;*/
        color: white;
        font-weight: bold;
        /*margin: 0 0 25px 0;*/
        user-select: none;
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 10px;
        background: #D83336;
        text-align: center;
    }

    .previous-step-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .active-previous-step:hover {
        background: #ad0c27;
        cursor: pointer;
    }

    .subcategory {
        padding: 0 10px;
        border-left: 3px solid #F2F2F2;
        color: #555555;
        font-weight: bold;
        margin: 12px 0;
        cursor: pointer;
        user-select: none;
        display: grid;
        grid-template-columns: auto max-content;
        grid-column-gap: 10px;
    }

    .subcategory:hover {
        color: #ad0c27;
        border-left: 3px solid #ad0c27;
    }

    .icon-container-previous-step {
        display: table; height: 100%
    }

    .icon-previous-step {
        width: 10px;
        display: table-cell;
        vertical-align: middle;
    }
</style>

<style>
    @media screen and (max-height: 800px) {
        .previous-step {
            font-size: 14px;
        }
        .subcategory {
            font-size: 14px;
        }
        .help-message{
            font-size: 14px;
        }
    }

    @media screen and (min-height: 800px) {
        .previous-step {
            font-size: 18px;
        }
        .subcategory {
            font-size: 18px;
        }
        .help-message{
            font-size: 18px;
        }
    }
    .help-message{
        padding: 15px 10px;
        color: #303030;
        font-weight: bold;
        margin: 0 0 25px 0;
        user-select: none;
        text-align: center;
    }

    .mt-30 {
        margin-top: 30px;
    }
</style>
